import { useEffect, useState } from "react";
import  { mutate } from 'swr';
import { apiGetStatistics } from "../../api";

const GetStatistics = ( {user} ) => {
    const [trigger, setTrigger] = useState(null);
    const [data, setData] = useState(null);
    useEffect(() => {
        if (trigger === null) {
            setTrigger(true);
        }
    }, []);
    

    const fetcher =  async () => {
        try {
          const data = await apiGetStatistics(user);
          setData(data);
          setTrigger(null);
    
          console.log("Data sent successfully");
        } catch (error) {
          console.error("Error sending data to server:", error.message);
        }
      }

    

    useEffect(() => {
        if (trigger === true && user !== undefined)  {
            mutate('statistics',fetcher,
            {
                revalidateIfStale: false,
                revalidateOnFocus: false,
                revalidateOnReconnect: false,
                errorRetryCount: 3,
                errorRetryInterval: 1000,
                onErrorRetry: (failureCount, error) => {
                    if (failureCount >= 3) {
                        alert("Πρόβλημα φόρτωσης των στατιτικών από τoν server: ", error)
                        
                    }
                    
                },
                onSuccess: () => {
                    
                    setTrigger(null);
                }
            })}}
    , [trigger,user]);

    
    
    return (
       data?data:null
    );
};

export default GetStatistics
